var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyThumbsup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1209 1364",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4400.7,-6617.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    transform: "matrix(0.487357,0,0,0.388667,4400.7,6617.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(17.7339,0,0,22.2369,593.31,7.19511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,51C102,22.852 79.148,0 51,0C22.852,0 0,22.852 0,51L0,106C0,134.148 22.852,157 51,157C79.148,157 102,134.148 102,106L102,51Z",
    style: {
      fill: "rgb(241,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14651,0,0,1.18573,-324.901,-271.653)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-5093.3,-3415.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3671.67,2126.6L3879.08,2183.05C3920.75,2194.03 3957.89,2217.9 3985.17,2251.26C4044.69,2324.05 4146.48,2448.51 4146.48,2448.51L3926.54,2604.92L3869.34,2526.37C3869.34,2526.37 3795.85,2751.18 3795.39,2807.94C3794.92,2864.69 3815.49,3025.88 3815.49,3025.88L3332.65,3025.88C3332.65,3025.88 3355.1,2845.68 3353.69,2798.94C3352.29,2752.2 3326.79,2621.83 3326.79,2621.83L3191.69,2650.86C3191.69,2650.86 3130.52,2622.1 3076.04,2596.49C3054.7,2586.46 3038.61,2567.86 3031.76,2545.3C3024.91,2522.74 3027.95,2498.33 3040.1,2478.13C3071.16,2426.38 3112.09,2358.77 3145.63,2305.47C3171.05,2265.05 3200.74,2227.51 3244,2207.29L3477.85,2126.75L3671.67,2126.6Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3671.67,2126.6L3879.08,2183.05C3920.75,2194.03 3957.89,2217.9 3985.17,2251.26C4044.69,2324.05 4146.48,2448.51 4146.48,2448.51L3926.54,2604.92L3869.34,2526.37C3869.34,2526.37 3795.85,2751.18 3795.39,2807.94C3794.92,2864.69 3815.49,3025.88 3815.49,3025.88L3332.65,3025.88C3332.65,3025.88 3355.1,2845.68 3353.69,2798.94C3352.29,2752.2 3326.79,2621.83 3326.79,2621.83L3191.69,2650.86C3191.69,2650.86 3130.52,2622.1 3076.04,2596.49C3054.7,2586.46 3038.61,2567.86 3031.76,2545.3C3024.91,2522.74 3027.95,2498.33 3040.1,2478.13C3071.16,2426.38 3112.09,2358.77 3145.63,2305.47C3171.05,2265.05 3200.74,2227.51 3244,2207.29L3477.85,2126.75L3671.67,2126.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2930.72,2713.52L3048.19,2502.8C3048.19,2502.8 3053.76,2498.51 3060.74,2493.13C3078.29,2479.62 3100.67,2474 3122.53,2477.62C3140.34,2480.57 3162.06,2484.16 3179.9,2487.12C3201.86,2490.75 3221.32,2503.39 3233.57,2521.98C3241.54,2534.08 3248.97,2545.35 3248.97,2545.35C3248.97,2545.35 3269.13,2528.23 3299.22,2502.87C3313.71,2490.65 3325.94,2480.35 3325.94,2480.35L3375.94,2610.25L3665.29,2597.71C3665.29,2597.71 3674.19,2598.53 3686.95,2599.7C3739.64,2604.55 3788.76,2572.6 3805.7,2522.48C3814.97,2495.04 3822.89,2471.61 3822.89,2471.61C3822.89,2471.61 3843.24,2487.72 3863.8,2503.99C3891.08,2525.58 3924.95,2537.13 3959.73,2536.7C4025.99,2535.89 4129.89,2534.62 4129.89,2534.62L3831.96,3078.82L3644.48,3038.69L3737.29,2944.36C3737.29,2944.36 3744.21,2891.97 3750.1,2847.34C3755.88,2803.55 3729.34,2761.94 3687.2,2748.72C3687.2,2748.72 3687.19,2748.72 3687.19,2748.72C3614.52,2725.92 3536.67,2725.55 3463.79,2747.64C3370.26,2775.99 3252.04,2811.82 3252.04,2811.82L2930.72,2713.52ZM3657.78,2190.09C3657.78,2190.09 3703.53,2216.2 3813.83,2252.82C3885.13,2276.49 3924.74,2230.64 3932.23,2187.07C3932.23,2187.07 3608.48,2074.02 3608.48,2074.02L3657.78,2190.09Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2517.03,1030)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,1.20453e-16,0,2.16989,-5081.83,-3495.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3007.33,2633.53C3007.33,2633.53 3021.28,2597.82 3034.22,2564.71C3046.76,2532.58 3080.32,2513.85 3114.25,2520.02C3132.64,2523.37 3153.24,2527.11 3172.68,2530.65C3192.4,2534.24 3209.74,2545.87 3220.53,2562.76C3231.32,2579.66 3234.58,2600.28 3229.55,2619.68C3221.62,2650.18 3214.3,2678.38 3214.3,2678.38L3007.33,2633.53Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0433711,2.16925,1.78916,0.0525849,-769.556,-1106.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1362.91,1735.25C1362.91,1735.25 1441.37,1786.61 1494.02,1821.07C1521.71,1839.19 1557.98,1837.13 1583.43,1815.99C1680.63,1735.27 1909.51,1545.2 1909.51,1545.2L1898.11,1454.79L1823.27,1508.53L1568.14,1646.34L1491.81,1562.97L1362.91,1735.25Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1362.91,1735.25C1362.91,1735.25 1441.37,1786.61 1494.02,1821.07C1521.71,1839.19 1557.98,1837.13 1583.43,1815.99C1680.63,1735.27 1909.51,1545.2 1909.51,1545.2L1898.11,1454.79L1823.27,1508.53L1568.14,1646.34L1491.81,1562.97L1362.91,1735.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1836.6,-506.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1485.7,1620.49C1485.7,1620.49 1590.23,1512.36 1696.12,1581.74L1679.23,1436.85L1568.11,1397.06L1458.14,1421.31L1084.89,1508.96L1170.38,1645.51L1485.7,1620.49Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.25005,1.55284,1.28075,1.51562,2636.75,-1918.66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.237404,-0.505817,0.417188,0.195806,574.967,1122.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0202657,1.98737,-1.63915,0.024571,2901.7,-1082.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.61,1301.89C1894.61,1301.89 1892.72,1291.38 1890.93,1281.39C1888.83,1269.69 1888.9,1257.72 1891.12,1246.05C1894.42,1228.73 1898.95,1204.91 1898.95,1204.91L1935.62,1223.9L1941.13,1277.36L1894.61,1301.89Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32858,-1.16426,-0.960257,-1.61083,-430.988,6946.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1931.02,1186.49 1946.96,1177.41C1952.05,1174.5 1958.47,1175.41 1962.56,1179.61C1962.56,1179.61 1962.56,1179.61 1962.56,1179.61C1965.02,1182.14 1966.37,1185.55 1966.3,1189.08C1966.24,1192.61 1964.76,1195.96 1962.21,1198.4C1951.4,1208.72 1935.39,1224 1935.39,1224L1898.62,1204.95Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,101.132,-152.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.560954,-0.827847,-0.919286,0.622914,4304.03,2159.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.97,1214.61C2040.97,1214.61 2042.43,1190.42 2043.34,1175.46C2043.52,1172.41 2045.05,1169.55 2047.59,1167.52C2050.12,1165.48 2053.45,1164.44 2056.84,1164.63C2056.84,1164.63 2056.84,1164.63 2056.84,1164.63C2063.35,1164.99 2068.49,1169.74 2068.73,1175.6C2069.35,1190.44 2070.4,1216.02 2070.4,1216.02L2040.97,1214.61Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.400184,-0.916435,-1.01766,0.444386,4074.61,2531.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.91,1211.14C2041.91,1211.14 2042.88,1189.46 2043.52,1175.48C2043.65,1172.44 2045.14,1169.57 2047.65,1167.53C2050.16,1165.49 2053.48,1164.45 2056.85,1164.63C2056.85,1164.63 2056.85,1164.63 2056.85,1164.63C2063.33,1164.99 2068.43,1169.75 2068.59,1175.59C2068.96,1189.5 2069.59,1212.52 2069.59,1212.52L2041.91,1211.14Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.6,1197.58 2042.1,1181.73C2042.22,1177.77 2043.83,1174.04 2046.54,1171.45C2049.25,1168.85 2052.82,1167.61 2056.39,1168.03C2056.65,1168.06 2056.91,1168.09 2057.17,1168.12C2063.56,1168.86 2068.49,1174.68 2068.74,1181.76C2069.32,1198.64 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.513049,-0.858359,-0.858359,0.513049,4060.69,2322.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.42,1174.12C2046.42,1174.12 2034.78,1153.24 2027.5,1140.16C2026.01,1137.49 2025.69,1134.31 2026.61,1131.39C2027.54,1128.48 2029.63,1126.07 2032.39,1124.74C2032.39,1124.74 2032.39,1124.74 2032.39,1124.74C2037.7,1122.18 2044.09,1124.15 2047.04,1129.25C2054.81,1142.65 2068.47,1166.21 2068.47,1166.21L2066.49,1167.26L2046.42,1174.12Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3993.3,2629.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975784,0.218737,-0.242898,1.08356,360.508,-575.194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.78,1213.22C2040.78,1213.22 2043.03,1193.81 2044.51,1181.03C2045.21,1174.9 2051.15,1170.37 2057.98,1170.75C2057.98,1170.75 2057.98,1170.75 2057.98,1170.75C2064.71,1171.12 2069.92,1176.22 2069.76,1182.3C2069.38,1197.45 2068.73,1223.09 2068.73,1223.09L2040.78,1213.22Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997418,0.0718087,-0.0718087,0.997418,106.167,-134.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2040.69,1195.67 2040.55,1179.17C2040.51,1175.29 2042.06,1171.57 2044.83,1168.87C2047.61,1166.16 2051.37,1164.7 2055.24,1164.83C2055.24,1164.83 2055.24,1164.83 2055.24,1164.83C2062.59,1165.07 2068.49,1170.98 2068.73,1178.33C2069.09,1189.69 2069.62,1205.93 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.504623,-0.816657,-0.850697,0.525657,4061,2244.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.44,1197.61 2040.06,1179.84C2039.89,1172.13 2046.25,1165.74 2054.28,1165.57C2054.28,1165.57 2054.28,1165.57 2054.28,1165.57C2062.17,1165.39 2068.73,1171.33 2069.03,1178.89C2069.78,1198.12 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2093.35,428.71 2083.98,418.282C2079.84,413.67 2079.43,406.806 2082.99,401.731C2083.05,401.647 2083.11,401.563 2083.17,401.478C2085.43,398.255 2089,396.198 2092.93,395.862C2096.85,395.525 2100.72,396.943 2103.5,399.734C2115.8,412.088 2133.82,430.189 2133.82,430.189L2180.66,505.744L2127.32,587.03C2127.32,587.03 2083.17,565.355 2078.82,559.124C2068.45,544.282 2043.18,508.696 2043.18,508.696Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2093.35,428.71 2083.98,418.282C2079.84,413.67 2079.43,406.806 2082.99,401.731C2083.05,401.647 2083.11,401.563 2083.17,401.478C2085.43,398.255 2089,396.198 2092.93,395.862C2096.85,395.525 2100.72,396.943 2103.5,399.734C2115.8,412.088 2133.82,430.189 2133.82,430.189L2180.66,505.744L2127.32,587.03C2127.32,587.03 2083.17,565.355 2078.82,559.124C2068.45,544.282 2043.18,508.696 2043.18,508.696Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2080.52,406.081C2080.52,406.081 2113.49,442.598 2108.6,445.733L2066.22,422.191L2060.12,419.893C2060.12,419.893 2064.23,416.846 2065.56,415.861C2065.84,415.659 2066.11,415.465 2066.4,415.28C2068.8,413.716 2080.52,406.081 2080.52,406.081Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.310378,-0.950613,-0.950613,0.310378,3952.71,1900.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1866.57,1255.82L1890.77,1278.25L1963.63,1264.76L1888.79,1227.27L1866.57,1255.82Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.27454,1.5233,-1.25639,1.5453,377.848,-2771.67)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.536323,-0.844013,0.844013,0.536323,-2116.8,2844.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3556.28,2479.87L3570.62,2456.97C3572.71,2453.64 3576.18,2451.42 3580.07,2450.93C3583.97,2450.43 3587.88,2451.7 3590.73,2454.4C3590.87,2454.53 3591,2454.65 3591.14,2454.78C3594.83,2458.26 3596.17,2463.56 3594.6,2468.38C3592.85,2473.72 3590.53,2479.28 3588.34,2484.07C3584.72,2492.01 3579.83,2499.32 3573.85,2505.69C3559.55,2520.96 3530.98,2551.46 3530.98,2551.46L3488.36,2528.99C3488.36,2528.99 3501.33,2517.8 3508.54,2511.57C3511.67,2508.87 3514.99,2506.39 3518.47,2504.15C3529.92,2496.77 3556.23,2479.81 3556.23,2479.81L3556.28,2479.87Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1601.65,1555.53C1566.99,1593.57 1565.38,1651.26 1597.87,1691.18C1597.87,1691.18 1597.88,1691.18 1597.88,1691.18C1617.21,1714.94 1647.1,1727.52 1677.61,1724.74C1708.12,1721.97 1735.24,1704.19 1749.97,1677.34C1828.17,1534.75 1948.25,1315.82 1948.25,1315.82L1921.81,1256.88L1887.01,1242.33C1887.01,1242.33 1700.72,1446.8 1601.65,1555.53Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1601.65,1555.53C1566.99,1593.57 1565.38,1651.26 1597.87,1691.18C1597.87,1691.18 1597.88,1691.18 1597.88,1691.18C1617.21,1714.94 1647.1,1727.52 1677.61,1724.74C1708.12,1721.97 1735.24,1704.19 1749.97,1677.34C1828.17,1534.75 1948.25,1315.82 1948.25,1315.82L1921.81,1256.88L1887.01,1242.33C1887.01,1242.33 1700.72,1446.8 1601.65,1555.53Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4218.3,1119.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2550.21,874.611C2550.21,874.611 2550.21,874.612 2550.21,874.613C2545.18,909.906 2518.52,938.235 2483.6,945.394C2448.68,952.552 2413.02,936.996 2394.51,906.527C2290.92,735.973 2159.19,519.091 2159.19,519.091L2228.83,472.704C2228.83,472.704 2332.36,704.39 2387.03,826.708C2406.29,869.814 2452.79,893.883 2499.11,884.721C2526.38,879.325 2550.21,874.611 2550.21,874.611Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97446,-0.224562,0.224562,0.97446,-235.752,453.257)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,101.132,-152.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.392051,0.919944,0.926316,-0.658832,109.666,126.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2047.38,1221.55C2047.38,1221.55 2045.52,1189.5 2044.57,1173.2C2044.27,1167.93 2048.6,1164.18 2054.6,1164.51C2054.6,1164.51 2054.6,1164.51 2054.6,1164.51C2058.07,1164.7 2061.6,1166.21 2064.3,1168.64C2066.99,1171.08 2068.59,1174.21 2068.69,1177.25C2069,1186.89 2069.44,1200.52 2069.78,1211.05C2069.92,1215.12 2068.08,1218.68 2064.71,1220.88C2061.34,1223.08 2056.75,1223.71 2052.05,1222.63C2049.31,1221.99 2047.38,1221.55 2047.38,1221.55Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.392051,0.919944,0.926316,-0.658832,93.7698,98.7487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2047.38,1221.55C2047.38,1221.55 2045.52,1189.5 2044.57,1173.2C2044.27,1167.93 2048.6,1164.18 2054.6,1164.51C2054.6,1164.51 2054.6,1164.51 2054.6,1164.51C2058.07,1164.7 2061.6,1166.21 2064.3,1168.64C2066.99,1171.08 2068.59,1174.21 2068.69,1177.25C2069,1186.89 2069.44,1200.52 2069.78,1211.05C2069.92,1215.12 2068.08,1218.68 2064.71,1220.88C2061.34,1223.08 2056.75,1223.71 2052.05,1222.63C2049.31,1221.99 2047.38,1221.55 2047.38,1221.55Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.392051,0.919944,0.926316,-0.658832,76.3397,75.6062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2047.38,1221.55C2047.38,1221.55 2045.52,1189.5 2044.57,1173.2C2044.27,1167.93 2048.6,1164.18 2054.6,1164.51C2054.6,1164.51 2054.6,1164.51 2054.6,1164.51C2058.07,1164.7 2061.6,1166.21 2064.3,1168.64C2066.99,1171.08 2068.59,1174.21 2068.69,1177.25C2069,1186.89 2069.44,1200.52 2069.78,1211.05C2069.92,1215.12 2068.08,1218.68 2064.71,1220.88C2061.34,1223.08 2056.75,1223.71 2052.05,1222.63C2049.31,1221.99 2047.38,1221.55 2047.38,1221.55Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.6,1197.58 2042.1,1181.73C2042.22,1177.77 2043.83,1174.04 2046.54,1171.45C2049.25,1168.85 2052.82,1167.61 2056.39,1168.03C2056.65,1168.06 2056.91,1168.09 2057.17,1168.12C2063.56,1168.86 2068.49,1174.68 2068.74,1181.76C2069.32,1198.64 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3993.3,2629.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.949194,-0.314693,0.349452,-1.05404,3599.56,3116.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2040.69,1195.67 2040.55,1179.17C2040.51,1175.29 2042.06,1171.57 2044.83,1168.87C2047.61,1166.16 2051.37,1164.7 2055.24,1164.83C2055.24,1164.83 2055.24,1164.83 2055.24,1164.83C2062.59,1165.07 2068.49,1170.98 2068.73,1178.33C2069.09,1189.69 2069.62,1205.93 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.525657,-0.850697,-0.850697,0.525657,4103.91,2314.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.46,1198.26 2040.07,1180.46C2039.89,1172.41 2046.27,1165.74 2054.32,1165.57C2054.32,1165.57 2054.32,1165.57 2054.32,1165.57C2062.19,1165.39 2068.74,1171.56 2069.05,1179.42C2069.8,1198.72 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2090.66,431.744 2078.16,422.546C2075.24,420.394 2073.33,417.136 2072.88,413.535C2072.43,409.933 2073.47,406.305 2075.78,403.499C2075.94,403.294 2076.11,403.088 2076.28,402.884C2080.66,397.54 2088.42,396.473 2094.09,400.433C2105.11,408.092 2122.67,420.604 2133.82,430.189C2145.93,440.589 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2090.66,431.744 2078.16,422.546C2075.24,420.394 2073.33,417.136 2072.88,413.535C2072.43,409.933 2073.47,406.305 2075.78,403.499C2075.94,403.294 2076.11,403.088 2076.28,402.884C2080.66,397.54 2088.42,396.473 2094.09,400.433C2105.11,408.092 2122.67,420.604 2133.82,430.189C2145.93,440.589 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2074.89,417.109C2074.89,417.109 2113.49,442.598 2108.6,445.733L2066.22,422.191L2060.12,419.893C2060.12,419.893 2060.12,419.893 2060.12,419.893C2063.86,417.125 2068.57,416.009 2073.15,416.806C2074.18,416.984 2074.89,417.109 2074.89,417.109Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,48.5761,166.926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1194.71,911.832L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1194.71,911.832L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081.89,1037.51C1081.89,1037.51 1099.57,1038.19 1117.86,1038.89C1140.15,1039.75 1157.77,1058.06 1157.77,1080.36L1157.77,1271.53L1384.15,1066.07L1192.43,931.554L1150.1,964.475L1081.89,1037.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1010.22,1105.14 1024.57,1074.59C1034.34,1053.8 1055.26,1040.53 1078.23,1040.56C1089.09,1040.58 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78314,0.185352,-0.152875,2.16196,-612.722,-1539.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3230.97,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.983331,-0.181822,0.181822,0.983331,-160.232,90.7034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.937008,-0.349307,-0.349307,0.937008,2482.46,424.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.986502,-0.163752,0.163752,0.986502,-125.026,179.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,2248.56,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.985176,0.171549,0.171549,0.985176,2082.44,-190.302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,-0.92542,1768.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.91,875.309 1161.36,879.583L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1085.09,977.305C1085.09,977.305 1106.57,984.859 1139.47,983.004L1138.49,1005.41C1138.49,1005.41 1097.02,1010.18 1085.09,977.305Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14651,0,0,1.02502,-23.6047,242.732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "rgb(14,27,91)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyThumbsup);
export default __webpack_public_path__ + "static/media/guy_thumbsup.1ca04766e7b98b7ad778a22ed88caaae.svg";
export { ForwardRef as ReactComponent };